/* unplugin-vue-components disabled */import script from "./footer-PC.vue?vue&type=script&lang=jsx"
export * from "./footer-PC.vue?vue&type=script&lang=jsx"

import "./footer-PC.vue?vue&type=style&index=0&id=54b9e372&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b9e372"]])

export default __exports__